import { Component, Input } from '@angular/core';
import { TextButtonVariant } from './../../enums/text-button-variant';

@Component({
  selector: 'evsb-text-button',
  templateUrl: './base-text-button.component.html',
})
export default class BaseTextButtonComponent {
  @Input()
  public class: string;
  protected variant = TextButtonVariant.secondary;

  public get className(): string {
    return `${this.variant} ${this.class}`;
  }
}
